import { useState } from 'react';
import BaseButton from 'components/atoms/baseButton';
import { useTranslation } from 'react-i18next';
import { useAddAllergyLog } from 'infrastructure/hooks/ccm';
import { isObjectValid } from 'infrastructure/functions';
import AllergyLogForm from 'components/molecules/admin-panel/forms/allergy-log';
import { usePatientInfo } from 'infrastructure/hooks/patient/use-patient-info';
import { isCcmActionAllowedStatus } from 'utils/userTypeHelper';

import AllergyLogTable from './components/allergy-table';
import s from './styles.module.scss';
import MasterModal from '../masterModal';

import type { Values } from 'components/molecules/admin-panel/forms/allergy-log/validation-schema';
import type { FC } from 'react';

interface PatientAllergyLogProps {
  patientGuid: string;
  disableActions?: boolean;
}

const PatientAllergyLog: FC<PatientAllergyLogProps> = ({
  patientGuid,
  disableActions = false,
}) => {
  const [page, setPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [refreshToken, setRefreshToken] = useState(0);
  const { t } = useTranslation();
  const { addAllergyLog, addLoading } = useAddAllergyLog();
  const { patientInfo, loading } = usePatientInfo({ patientGuid });
  const disableButton = !isCcmActionAllowedStatus(patientInfo?.ccmStatus);

  const toggleOpen = () => setOpen((prev) => !prev);

  const onSubmit = async (values: Values) => {
    if (isObjectValid(values))
      addAllergyLog(
        { ...values, patientGuid },
        {
          onSuccess: () => {
            toggleOpen();
            setRefreshToken((prev) => prev + 1);
          },
        },
      );
  };

  const onCancelForm = () => {
    toggleOpen();
  };

  return (
    <>
      <div className={s.wrapper} id="allergy-history">
        <div className={s['title-wrapper']}>
          <BaseButton
            label={`+ ${t('labels.addAllergy')}`}
            dataCy="addAllergy-button"
            onClick={toggleOpen}
            loading={addLoading}
            data-cy="add-allergy-log-btn"
            disabled={disableActions || disableButton || loading}
          />
        </div>
        <AllergyLogTable
          patientGuid={patientGuid}
          page={page}
          setPage={setPage}
          disableActions={disableActions || disableButton}
          refreshToken={refreshToken}
        />
      </div>
      {open && (
        <MasterModal
          title={t('labels.addAllergy')}
          isOpen={open}
          toggle={toggleOpen}
          bodyClassName={s['modal-body']}
          modalClassName={s.modal}
          footerClassName={s['modal-footer']}
        >
          <AllergyLogForm
            loading={addLoading}
            onSubmit={onSubmit}
            onCancelForm={onCancelForm}
          />
        </MasterModal>
      )}
    </>
  );
};
export default PatientAllergyLog;
